/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog, Grid, Typography2 } from '@coursera/cds-core';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  isOpen: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

export const OptOutModal = ({ isOpen, onSubmit, onCancel }: Props): React.ReactElement => {
  const { Content, Actions, HeadingGroup } = Dialog;

  return (
    <Dialog variant="transactional" aria-describedby="dialog-content" open={isOpen} onClose={onCancel}>
      <HeadingGroup>{_t('Opt out of memory')}</HeadingGroup>
      <Content id="dialog-content">
        <Typography2
          variant="bodyPrimary"
          component="p"
          css={css`
            color: var(--cds-color-grey-700);
          `}
        >
          {_t(
            `By selecting opt-out, you will turn off #{coachLabel} remembering details from your future chats to personalize your experience.
            You can delete the memories #{coachLabel} has previously saved in Memory setting. Otherwise they will remain saved.`,
            { coachLabel: 'Coach' }
          )}
        </Typography2>
      </Content>

      <Actions>
        <Grid container spacing={16}>
          <Grid item>
            <CoachButton variant="primary" onClick={onSubmit}>
              {_t('Opt out')}
            </CoachButton>
          </Grid>
          <Grid item>
            <CoachButton variant="secondary" onClick={onCancel}>
              {_t('Cancel')}
            </CoachButton>
          </Grid>
        </Grid>
      </Actions>
    </Dialog>
  );
};

export default OptOutModal;
